import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { stringToColor } from '@sceneio/tools'

export const selectUser = (state: RootState) => {
  return state.user
}

export const selectMyUserId = (state: RootState) => {
  return state.user.id
}

export const selectIsLoggedIn = (state: RootState) => {
  return Boolean(state.user.token)
}

export const selectName = (state: RootState) => {
  return state.user.name
}

export const selectNameLetter = createSelector([selectName], (name) => {
  return name.charAt(0).toUpperCase()
})

export const selectEmail = (state: RootState) => {
  return state.user.email
}

export const selectProjectAclRoleName = (state: RootState) => {
  const { aclRole } = state.user.selectedProject
  return aclRole?.name
}

export const selectProjectAclRoleId = (state: RootState) => {
  const { aclRole } = state.user.selectedProject
  return aclRole?.id
}

export const selectColor = createSelector([selectEmail], (email) => {
  return stringToColor(email)
})

export const selectMyWorkspaceId = (state: RootState) => {
  return state.user.myWorkspaceId
}
